// @flow

import { type Grecaptcha } from './types';

export class LoadGrecaptcha {
  loadFn: () => Promise<Grecaptcha>;
  maxTries: number;
  tries: number = 0;
  started: boolean = false;
  loaded: ?Grecaptcha = null;
  lastError: ?Error = null;

  constructor(loadFn: () => Promise<Grecaptcha>, maxTries: number) {
    this.loadFn = loadFn;
    this.maxTries = maxTries;
  }

  async execute(): Promise<Grecaptcha> {
    if (this.started) {
      throw new Error('LoadGrecaptcha - Illegal State - already started loading before');
    }
    return this._load();
  }

  async _load(): Promise<Grecaptcha> {
    this.started = true;
    while (this.tries < this.maxTries) {
      try {
        this.tries++;
        this.loaded = await this.loadFn();
        this.lastError = null;
        break;
      } catch(error) {
        this.lastError = error;
      }
    }
  }

  getLoaded(): ?Grecaptcha {
    return this.loaded;
  }

  triesCount(): number {
    return this.tries;
  }

  getLastError(): ?Error {
    return this.lastError;
  }
}
